// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3l0J9","bigColWidth":"Table_bigColWidth__3ptET","biggerColWidth":"Table_biggerColWidth__3qd4l","row":"Table_row__1i_sE","col":"Table_col__2BjPV"};